<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Charges&nbsp;</a>
    </small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Charges&nbsp;</a>
    </small>
    <small *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER'">
      <a [routerLink]="['/service-provider/dashboard']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/service-provider/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Charges&nbsp;</a>
    </small>
    <small *ngIf="accountCategory== 'DEALER'">
      <a [routerLink]="['/dealer']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Charges&nbsp;</a>
    </small>
    <small *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'">
      <a [routerLink]="['/corporate']" class="text-secondary">Admin Console&nbsp;</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a class="text-secondary pointer">&nbsp;Charges&nbsp;</a>
    </small>
  </div>
</div>

<div *ngIf="isChargingPeriodAvailable()" class="col-sm-12 card bg-light p-2 mt-3">
  <div class="text-secondary mb-2 font13-400">Please select time period for which you want to
    view charges</div>
  <div>
    <label>Select Period:&nbsp;&nbsp;</label>
    <select id="loc" class="date-dropown" [(ngModel)]="selectedSelectionRange"
      (change)="onChargingPeriodChange($event.target.selectedIndex)" name="selectionOption" #selectionOption="ngModel">
      <option *ngFor="let dateRange of chargingPeriodOptions; let i = index;" [ngValue]="dateRange">
        {{dateRange.periodName}}
      </option>
    </select>
    <!-- <label *ngIf="selectedFromDate && selectedToDate" class="ml-2">({{selectedFromDate | date: 'MM/dd/yyyy': 'Z'}} -
      {{selectedToDate | date: 'MM/dd/yyyy': 'Z'}})</label> -->
  </div>
</div>

<!--Package wise charge start-->
<ng-container *ngIf="charges && charges.length > 0">
  <div class="col-12 card mt-4 mb-4 bg-light" *ngFor="let charge of charges;">
    <div class="row no-gutters" *ngIf="charge">
      <!-- <ng-container *ngIf="isHertzAccount() else otherAccount"> -->
      <div class="col-12 mt-3 heading">Package Wise Charges</div>
      <div class="col-12">
        <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
          <table class="table table-striped">
            <thead class="thead-light">
              <tr>
                <th width="17%" scope="col">Name</th>
                <th width="17%" scope="col" >Rate Plan</th>
                <th width="17%" scope="col" >Vehicles</th>
                <th width="17%" scope="col" >Sub Total</th>
                <th width="16%" scope="col" >Tax</th>
                <th width="16%" scope="col" >Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>{{charge.packageName}}</span>
                </td>
                <td>
                  <span>{{charge.ratePlanType | customText}}</span>
                  <span *ngIf="charge.appliedAs && charge.appliedAs=='TRIAL'">&nbsp;(Trial)</span>
                </td>
                <td *ngIf="accountCategory != 'UTILITY_COMPANY'">
                  <span>{{charge.endVehiclesCount}}</span>
                </td>
                <td *ngIf="accountCategory == 'UTILITY_COMPANY'">
                  <span>-</span>
                </td>
                <td><span>{{charge.charge.subTotal}}</span></td>
                <td><span>{{charge.charge.taxes}}</span></td>
                <td><span>{{charge.charge.total}}</span></td>
              </tr>
              <tr *ngIf="accountType != 'VEHICLE_SERVICE_PROVIDER'">
                <td colspan="2">
                  <label>Number of vehicles added: <b>{{charge.vehiclesAdded}}</b></label>
                </td>
                <td colspan="2">
                  <label>Number of vehicles removed: <b>{{charge.vehiclesRemoved}}</b></label>
                </td>
                <td colspan="2">
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <label>Total Transactions: <b>{{getTotalTransactions(charge.serviceCharges)}}</b></label>
                </td>
                <td colspan="2">
                  <label>Successful Transactions: <b>{{getSuccessfulTransactions(charge.serviceCharges)}}</b></label>
                </td>
                <td colspan="2">
                  <label>Failed Transactions: <b>{{getFailedTransactions(charge.serviceCharges)}}</b></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- </ng-container> -->
      <!-- <ng-template #otherAccount>
        <div class="col-12 mt-3 heading">Package Wise Charges</div>
        <div class="col-12">
          <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
            <table class="table table-striped">
              <thead class="thead-light">
                <tr>
                  >!-- <th width="25%" scope="col">Package Id</th> --<
                  <th width="25%" scope="col">Name</th>
                  <th width="25%" scope="col" class="text-center">Vehicles</th>
                  <th width="25%" scope="col" class="text-center">Rate Plan</th>
                  <th width="25%" scope="col" class="text-center">Amount ({{utilService.countryData.currency}})</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  >!-- <td>
                    <span>{{charge.packageId}}</span>
                  </td> --<
                  <td>
                    <span>{{charge.packageName}}</span>
                  </td>
                  <td class="text-center" *ngIf="accountCategory != 'UTILITY_COMPANY'">
                    <span>{{charge.vehiclesCount}}</span>
                  </td>
                  <td class="text-center" *ngIf="accountCategory == 'UTILITY_COMPANY'">
                    <span>-</span>
                  </td>
                  <td class="text-center">
                    <span>{{charge.ratePlanType | customText}}</span>
                    <span *ngIf="charge.appliedAs && charge.appliedAs=='TRIAL'">&nbsp;(Trial)</span>
                  </td>
                  <td class="text-center">
                    <span *ngIf="charge.amount == null || charge.amount == undefined || charge.amount == 0">NIL</span>
                    <span *ngIf="charge.amount && charge.amount > 0">{{charge.amount | number : '1.2-2'}}</span>
                  </td>
                </tr>
                <tr *ngIf="accountType != 'VEHICLE_SERVICE_PROVIDER'">
                  <td colspan="2">
                    <label>Number of vehicles added: <b>{{charge.vehiclesAdded}}</b></label>
                  </td>
                  <td colspan="3">
                    <label>Number of vehicles removed: <b>{{charge.vehiclesRemoved}}</b></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-template> -->

      <!-- <div class="col-6 mt-3 mb-2 text-center">
        <label>Number of vehicles added: <b>{{charge.vehiclesAdded}}</b></label>
      </div>
      <div class="col-6 mt-3 mb-2 text-center">
        <label>Number of vehicles removed: <b>{{charge.vehiclesRemoved}}</b></label>
      </div> -->

      <!-- <ng-container *ngIf="!isHertzAccount() && charge.serviceCharges && charge.serviceCharges.length > 0">
        <div class="col-12 mt-3 heading">Service Wise Transactions</div>
        <div class="col-12">
          <div class="table-responsive col-12 mt-3 pb-1 pl-0 pr-0">
            <table class="table table-striped tbl-scrollable">
              <thead class="thead-light">
                <tr>
                  >!-- <th width="25%" scope="col">Service Id</th> --<
                  <th width="25%" scope="col">Name</th>
                  <th width="25%" scope="col" class="text-center">Successful Transactions</th>
                  <th width="25%" scope="col" class="text-center">Failed Transactions</th>
                  <th width="25%" scope="col" class="text-center">Total Transactions</th>
                </tr>
              </thead>
              <tbody class="max-height-25">
                <tr class="pointer xs-disable" *ngFor="let serviceCharge of charge.serviceCharges"
                  (click)="serviceCharge.totalTransactions > 0 ? getUDR(serviceCharge.serviceName) : ''">
                  >!-- <td>
                    <span>{{serviceCharge.serviceId}}</span>
                  </td> --<
                  <td width="25%">
                    <span>{{serviceCharge.serviceName}}</span>
                  </td>
                  <td width="25%" class="text-center">
                    <span>{{serviceCharge.successfulTransactions | number:'1.0': LOCALE}}</span>
                  </td>
                  <td width="25%" class="text-center">
                    <span>{{serviceCharge.failedTransactions | number:'1.0': LOCALE}}</span>
                  </td>
                  <td width="25%" class="text-center">
                    <span>{{serviceCharge.totalTransactions | number:'1.0': LOCALE}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container> -->
    </div>
  </div>
</ng-container>

<div *ngIf="(charges == null || charges.length < 1) && isChargingPeriodAvailable()" class="col-12 mt-5 text-center">
  <h3 class="text-muted">No charging data available for the selected period.</h3>
</div>
<div *ngIf="!isChargingPeriodAvailable()" class="col-12 mt-5 text-center">
  <h3 class="text-muted">Charging data will be available after the current billing cycle.</h3>
</div>

<!--View Service Usage Modal-->
<button type="button" class="btn btn-primary" id="openServiceUsage" [hidden]="true" data-toggle="modal"
  data-target="#serviceUsage" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal" id="serviceUsage" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="serviceUsageTitle" style="line-height: 20px;">
          {{selectedService}} Usage
        </h5>
        <button type="button" id="closeServiceUsage" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="padding-2 hide-x-scroll modal-body">
        <app-view-service-usage [usageData]="usageData" [locationMap]="locationMap"></app-view-service-usage>
      </div>
    </div>
  </div>
</div>